import type { TerritoryChipsFilterOptions } from 'components/TerritoryChipsFilter/types'
import { FORMAT_CATEGORY_IDS_ARRAY } from 'consts/formatCategoryIds'
import type {
  EnumTerritoriesFiltersType,
  ListTerrotoriesSortFields,
  ListTerrotoriesSortOrder,
  TaxonomyLanguages,
  TimeUnit,
} from 'generated/graphql'
import { shouldBeArray } from 'utils'
import { getAudienceValuesFromObject } from 'utils/getAudienceValuesFromObject'

import { getCurrentType } from '../getCurrentType'
import { getLanguageVariables } from '../getLanguageVariable'

export type OrderOption = { field: ListTerrotoriesSortFields; order: ListTerrotoriesSortOrder }

export const getVariables = (filters: TerritoryChipsFilterOptions, search: string, order: OrderOption, take = 24) => {
  const currentType = getCurrentType(filters?.territoryTypes)
  const currentLanguage = getLanguageVariables(filters?.languages, filters?.territoryTypes) as unknown

  const timeRange = {
    timeUnit: 'month' as TimeUnit,
    timeValue: filters?.dateRange ?? 12,
  }

  const isBrandCategory = filters?.territoryTypes === 'brandCategory'
  const isolatedTopicId = filters?.topics?.split('.')?.[1]
  const selectedCategory = filters?.categories ? [filters?.categories] : []

  const audienceValues = getAudienceValuesFromObject(filters?.audience)
  const audienceObject = {
    ages: shouldBeArray(audienceValues?.ages),
    countries: shouldBeArray(audienceValues?.countries),
    genders: shouldBeArray(audienceValues?.genders),
  }

  return {
    pagination: {
      take,
    },
    filters: {
      types: currentType as EnumTerritoriesFiltersType[],
      onlyFavorites: filters?.territoryTypes === 'favorites',
      language: currentLanguage as TaxonomyLanguages[],
      title: search,
      industryOnly: isBrandCategory,
      category:
        filters?.territoryTypes === 'formats' ? FORMAT_CATEGORY_IDS_ARRAY.map(item => String(item)) : selectedCategory,
      topics: filters?.topics ? [isolatedTopicId] : [],
      timeRange,
    },
    audience: audienceObject,
    timeRange,
    sort: order,
    ...audienceObject,
  }
}
